import { DataService } from 'api/DataService'

import { apiErrorMessage } from 'utils/apiErrorMessage'
import { UploadFileType } from 'utils/customFieldUpload'

export interface PayloadCreateExtraField {
  field_configuration: {
    title: string
    description?: string
    options?: { label: string; value: string }[]
    type?: 'file' | 'link' | 'text'
    value?: string
    accept_text?: string
    display_mode?: 'list' | 'dropdown'
    accepted_types?: UploadFileType[]
    multiple?: boolean
    max_files?: number
  }
  field_type: number
  document_uuid?: string
}

export class ExtraFieldsService {
  public static async getAll({
    filter_by
  }: {
    filter_by: string
  }): Promise<any> {
    const response = await DataService({
      type: 'GET',
      url: `/v1/custom_fields/${filter_by}`
    })

    if (response.status === 200) {
      return response?.data
    }

    return {
      error: true,
      message: 'Erro ao buscar campos extras'
    } as any
  }

  public static async getByUUID(uuid: string): Promise<any> {
    const response = await DataService({
      type: 'GET',
      url: `/v1/custom_fields/${uuid}`
    })

    if (response.status === 200) {
      return response?.data
    }

    return {
      error: true,
      message: 'Erro ao buscar campos extras'
    } as any
  }

  public static async create(payload: PayloadCreateExtraField): Promise<any> {
    const response = await DataService({
      type: 'POST',
      url: `/v1/custom_fields`,
      data: payload
    })

    if (response.status === 201) {
      return response?.data
    }

    return {
      error: true,
      message: apiErrorMessage(response, 'Erro ao criar campo extra.')
    } as any
  }

  public static async update(
    uuid: string,
    payload: PayloadCreateExtraField
  ): Promise<any> {
    const response = await DataService({
      type: 'PATCH',
      url: `/v1/custom_fields/${uuid}`,
      data: payload
    })

    if (response.status === 200) {
      return response?.data
    }

    return {
      error: true,
      message: apiErrorMessage(response, 'Erro ao atualizar campo extra.')
    } as any
  }

  public static async delete(uuid: string): Promise<any> {
    const response = await DataService({
      type: 'DELETE',
      url: `/v1/custom_fields/${uuid}`
    })

    if (response.status === 200) {
      return response?.data
    }

    return {
      error: true,
      message: apiErrorMessage(response, 'Erro ao deletar campo extra.')
    } as any
  }
}
